import { render, staticRenderFns } from "./VesselCard.vue?vue&type=template&id=0d44c5c2&scoped=true&"
import script from "./VesselCard.vue?vue&type=script&lang=js&"
export * from "./VesselCard.vue?vue&type=script&lang=js&"
import style0 from "./VesselCard.vue?vue&type=style&index=0&id=0d44c5c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d44c5c2",
  null
  
)

export default component.exports